// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"866":"f29b2934723cd127","3283":"8c959031cf7a31a2","5878":"55f9018349bf7882","8336":"0b4e0f70beb405fb"}[chunkId] + ".css";
};